import {ModuleWithProviders} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {InvestigationComponent} from './investigation.component';

const routes: Routes = [
  //  { path: 'login', loadChildren: 'app/login/login.module#LoginModule' },
  {
    path: 'investigation', component: InvestigationComponent,
    children: [
      {path: 'pathology', loadChildren: 'app/investigation/pathology/pathology.module#PathologyModule'},
      {path: 'radiology', loadChildren: 'app/investigation/radiology/radiology.module#RadiologyModule'}
    ]
  }
];
export const routing: ModuleWithProviders = RouterModule.forChild(routes);



// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/investigation/investigation.routing.ts